var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPlaceholderRetailerLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 782,
    height: 523,
    viewBox: "0 0 782 523",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 782,
    height: 523,
    rx: 40,
    fill: "#F8FAFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_128:5)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M478.34 191.93C478.23 191.71 478.23 191.6 478.12 191.49L477.79 190.5H477.68C475.7 187.2 472.29 185 468.22 185H314.22C309.6 185 305.75 187.75 304.1 191.71L281 245.5H281.22C281.22 260.68 293.54 273 308.72 273C323.9 273 336.22 260.68 336.22 245.5C336.22 260.68 348.54 273 363.72 273C378.9 273 391.22 260.68 391.22 245.5C391.22 260.68 403.54 273 418.72 273C433.9 273 446.22 260.68 446.22 245.5C446.22 260.68 458.54 273 473.72 273C488.9 273 501.22 260.68 501.22 245.5L478.34 191.93ZM314.22 174H468.22C474.27 174 479.22 169.05 479.22 163C479.22 156.95 474.27 152 468.22 152H314.22C308.17 152 303.22 156.95 303.22 163C303.22 169.05 308.06 174 314.22 174ZM457.22 328H325.22V284H303.22V361C303.22 367.05 308.17 372 314.22 372H468.22C474.27 372 479.22 367.05 479.22 361V284H457.22V328Z",
    fill: "#94A3B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_128:5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 220,
    height: 220,
    fill: "white",
    transform: "translate(281 152)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderRetailerLogo);
export default __webpack_public_path__ + "static/media/PlaceholderRetailerLogo.e4ebee14f91f1414fe2af2748e7baede.svg";
export { ForwardRef as ReactComponent };